<div class="main">
  <p class="repair-header">{{'Post Repair Procedures'|translate}}</p>
  <p class="repair-title">{{'Post Repair Procedures Text1'|translate}}</p>
  <div class="table">
    <table style="width: 100%">
      <thead>
        <tr>
          <th>{{'Post Repair Procedures'|translate}}</th>
          <th>{{'State'|translate}}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let c of temp">
          <td><img src="assets/images/pinpoint.gif">{{c.title}}</td>
          <td *ngIf="c.kind == 'TSB-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Error')? 'red' : 'green' }">{{c.result.state|translate|titlecase}}</td> 
          <td *ngIf="c.kind == 'PINPOINT-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Error')? 'red' : 'green' }">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'OTX-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Tested' || c.result.state == 'Aborted')? 'green': 'red'}">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'OTX_DIAGNOSTIC-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Tested' || c.result.state == 'Aborted')? 'green': 'red'}">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'OTX-SERVFUNC-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Tested' || c.result.state == 'Aborted')? 'green': 'red'}">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'GENERAL-INFORMATION-CANDIDATE'" [ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Error')? 'red' : 'green' }">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'ETIS-CANDIDATE'"[ngStyle]="{'color': (c.result.state == 'Unread' || c.result.state == 'Untested')? 'gray' : (c.result.state == 'Error')? 'red' : 'green' }">{{c.result.state|translate|titlecase}}</td>
          <td *ngIf="c.kind == 'OTX-CANDIDATE' || c.kind == 'OTX_DIAGNOSTIC-CANDIDATE' || c.kind == 'OTX-SERVFUNC-CANDIDATE'">
            <button class="button" (click)="navigateToTest(c.procRef.procUidRef,c.kind,c.procRef.uidRef,c.title,content,networkTestConfirmation)">{{'RUN'|translate}}</button>
          </td>
          <td *ngIf="c.kind == 'TSB-CANDIDATE' || c.kind == 'PINPOINT-CANDIDATE' || c.kind == 'GENERAL-INFORMATION-CANDIDATE' || c.kind == 'REPAIR-INFO-CANDIDATE' || c.kind == 'ETIS-CANDIDATE'">
            <button class="button" (click)="navigateToTest(c.procRef.procUidRef,c.kind,c.procRef.uidRef,c.title,content,networkTestConfirmation)">{{'VIEW'|translate}}</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <button class="buttons repair-btn" (click)="navigateToRepQua()">{{btnName|translate}}</button>
</div>
<div  style="text-align:center; margin-top:-10%" *ngIf="FDRSStatusLoader">
  <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>
</div>
<div id="overlay" *ngIf="viewCompletePostRepair">
  <span id="nav-spinner">
    <img src="assets/images/ajax-loader.gif" width="80" height="80">
  </span>
</div>
<ng-template #content let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="mng-qualifier-header-popup" id="exampleModalLongTitle">{{'Information'|translate}}</div>
      <i class="fa fa-times" style="cursor: pointer" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="info-s">
      <p>{{'Diagnosis and Repair info'|translate}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="buttons" (click)="modal.dismiss('Cross click')">{{'Continue'|translate}}</button>
    </div>
  </div>
</ng-template>
<ng-template #networkTestConfirmation let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <div class="modal-title mng-qualifier-title mng-qualifier-header-popup" id="exampleModalLongTitle">
        {{'Information'|translate}}</div>
      <i class="fa fa-times mng-qualifier-close-btn" (click)="modal.dismiss('Cross click')"></i>
    </div>
    <div class="deleteContent info-s">
      <p>{{'No current Network Test results available'|translate}}: {{'Network Test Message2'|translate}}. {{'Please ensure that the GFDRS client is connected'|translate}}.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="buttons"
        (click)="modal.dismiss('Cross click');navigateToNetworkTest()">{{'YES'|translate}}</button>
      <button type="button" class="buttons" (click)="modal.dismiss('Cross click');">{{'NO'|translate}}</button>
    </div>
  </div>
</ng-template>